/**
 * Where the Amount on a Paid entry of the Payment Status History came from:
 * the Total Cost entered on the Prod Payables MS row, or the amount calculated
 * from the Subdivision/Region rates when the row held no Total Cost.
 */
export enum JobPhasePaidAmountSourceEnum {
  TotalCost = 'TotalCost',
  Calculated = 'Calculated',
}
